import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavigationComponent } from './top-navigation.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [TopNavigationComponent],
  exports: [TopNavigationComponent],
  imports: [CommonModule, RouterModule],
})
export class TopNavigationModule {}
